<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="14.37261962890625"
    height="29.3909912109375"
    viewBox="0 0 14.37261962890625 29.3909912109375"
    fill="none"
  >
    <g opacity="1" transform="translate(0 0)  rotate(0)">
      <g opacity="1" transform="translate(0 0)  rotate(0)">
        <g opacity="1" transform="translate(0 0)  rotate(0)">
          <g opacity="1" transform="translate(0 0)  rotate(0)">
            <g opacity="1" transform="translate(0 0)  rotate(0)">
              <path
                id="形状 19 拷贝 18"
                fill-rule="evenodd"
                fill="url(#linear_icon_0)"
                opacity="1"
                d="M0 0ZM14.37 15.2L0 0L0 29.39L14.37 15.2Z"
              ></path>
              <path
                id="形状 19 拷贝 18"
                fill-rule="evenodd"
                fill="url(#linear_icon_1)"
                opacity="1"
                d="M1.02631 9.12134ZM7.18631 15.4113L1.02631 9.12134L1.02631 21.2813L7.18631 15.4113Z"
              ></path>
            </g>
          </g>
        </g>
      </g>
      <g opacity="1" transform="translate(0 0)  rotate(0)">
        <g opacity="1" transform="translate(0 0)  rotate(0)">
          <g opacity="1" transform="translate(0 0)  rotate(0)">
            <g opacity="1" transform="translate(0 0)  rotate(0)">
              <path
                id="形状 19 拷贝 18"
                fill-rule="evenodd"
                fill="url(#linear_icon_2)"
                opacity="1"
                d="M0 0ZM14.37 15.2L0 0L0 29.39L14.37 15.2Z"
              ></path>
              <path
                id="形状 19 拷贝 18"
                fill-rule="evenodd"
                fill="url(#linear_icon_3)"
                opacity="1"
                d="M1.02631 9.12134ZM7.18631 15.4113L1.02631 9.12134L1.02631 21.2813L7.18631 15.4113Z"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="linear_icon_0"
        x1="204.8545821077758%"
        y1="50%"
        x2="-10.328199919919708%"
        y2="50%"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#FF9F1B" stop-opacity="1" />
        <stop offset="0.42676299810409546" stop-color="#EA9219" stop-opacity="0.8314" />
        <stop offset="1" stop-color="#80500E" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="linear_icon_1"
        x1="204.82162819548%"
        y1="50%"
        x2="-10.31536174501996%"
        y2="50%"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#FF9F1B" stop-opacity="1" />
        <stop offset="0.42676299810409546" stop-color="#EA9219" stop-opacity="0.8314" />
        <stop offset="1" stop-color="#FF9400" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="linear_icon_2"
        x1="204.8545821077758%"
        y1="50%"
        x2="-10.328199919919708%"
        y2="50%"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#FF9F1B" stop-opacity="1" />
        <stop offset="0.42676299810409546" stop-color="#EA9219" stop-opacity="0.8314" />
        <stop offset="1" stop-color="#80500E" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="linear_icon_3"
        x1="204.82162819548%"
        y1="50%"
        x2="-10.31536174501996%"
        y2="50%"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stop-color="#FF9F1B" stop-opacity="1" />
        <stop offset="0.42676299810409546" stop-color="#EA9219" stop-opacity="0.8314" />
        <stop offset="1" stop-color="#FF9400" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
